import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DeleteFulfillmentPlanConfirmationModal } from '../../../../../../fulfillment-plans/delete-modal';
import { useFulfillmentPlanDeleteStatus } from '../../../../../../fulfillment-plans/delete-modal/hooks';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useDeleteFulfillmentPlan } from '../../../../../../fulfillment-plans/delete-modal/use-delete-fulfillment-plan';

const DeleteShipmentMenuItemModal = ({ onClose }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const [errorCode, setErrorCode] = useState(undefined);
  const { canDelete } = useFulfillmentPlanDeleteStatus(fulfillmentPlanId) ?? {};

  const onDelete = useDeleteFulfillmentPlan({
    fulfillmentPlanId,
    onSuccess: onClose,
    onError: setErrorCode,
  });

  if (!canDelete) {
    return null;
  }

  return <DeleteFulfillmentPlanConfirmationModal errorCode={errorCode} onClose={onClose} onDelete={onDelete} />;
};

DeleteShipmentMenuItemModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default DeleteShipmentMenuItemModal;
